module.exports = __webpack_public_path__ + "img/3.c93255c2.png";